import script from "./PopUp.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUp.vue?vue&type=script&setup=true&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=c54cf3be&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c54cf3be"]])

export default __exports__